import {WatchlistType} from "./WatchlistType";

export type WatchlistId = string & { __watchlistId: string };

export function CreateWatchlistId(identifier: string | number, type: WatchlistType) {
    return `${type}:${identifier}` as WatchlistId;
}

export function extractActualId(id: WatchlistId): number {
    if (id.startsWith(WatchlistType.SYSTEM)) {
        throw Error("Cannot extract actual ID from a SYSTEM watchlist ID");
    } else {
        return +id.replace(WatchlistType.USER, "")
                  .replace(":", "");
    }
}
